

const size = {
	down: {
		xs: `(max-width: 599px)`,
		sm: `(max-width: 959px)`,
		md: `(max-width: 1439px)`,
		lg: `(max-width: 1919px)`,
		xl: `(max-width: 2139px)`,
	},
	up: {
		xs: `(min-width: 0px)`,
		sm: `(min-width: 600px)`,
		md: `(min-width: 960px)`,
		lg: `(min-width: 1440px)`,
		xl: `(min-width: 1920px)`,
	},
	mobileS: '320px',
	mobileM: '375px',
	mobileL: '425px',
	tablet: '768px',
	laptop: '1024px',
	laptopL: '1440px',
	desktop: '2560px'
}

export default size